import React, { useContext } from 'react';
import { ThemeContext } from '@context/ThemeContext';
import GlobalChart from '@components/redesign/GlobalChart';
import adoptionRateByBU from '@v2/charts/tpo/adoptionRateByBU';
import KpiContainer from '@components/redesign/KpiContainer';
import { useDynamicGraphQLQuery } from '@hooks/useDynamicGraphQLQuery';

interface AdoptionRateByBUProps {
  title?: string;
  selectedMarkets?: Array<{ id: string; displayText: string }>;
}

const AdoptionRateByBU: React.FC<AdoptionRateByBUProps> = ({
  title = 'Adoption Rate by BU',
  selectedMarkets = [],
}) => {
  const { mode } = useContext(ThemeContext);

  // Extract market IDs for the GraphQL query
  const marketIds = selectedMarkets.map((market) => parseInt(market.id));

  const { data: adoptionRateBUData, isLoading: adoptionRateBUDataLoading } =
    useDynamicGraphQLQuery('getAdoptionRateByMarket', {
      marketIdList: marketIds.length > 0 ? marketIds : [],
      persona: null,
    });
  const chartOption = adoptionRateBUDataLoading
    ? {}
    : adoptionRateByBU.handler(
        adoptionRateBUData?.getAdoptionRateByMarket?.data || [],
        mode
      );

  const getNoDataFound = () => {
    return !adoptionRateBUData?.getAdoptionRateByMarket?.data?.length;
  };

  return (
    <KpiContainer title={title}>
      <GlobalChart
        noDataFound={getNoDataFound()}
        options={chartOption}
        isLoading={adoptionRateBUDataLoading}
        bottomMargin={20}
        customLeftMargin={30}
      />
    </KpiContainer>
  );
};

export default AdoptionRateByBU;
